export default __webpack_public_path__ + "baa863a1a12a2c8a4bfd648991067e71.svg";